export default __webpack_public_path__ + "static/media/EAU POTABLE.7230a4f6.svg";